import { createFileRoute } from "@tanstack/react-router"
import PlayersAndDevices from "@/app/settings/club/players/page"

export const Route = createFileRoute("/settings/club/players")({
  component: PlayersAndDevices,
})
